import type CalendarState from "../calendarState";
import {Action} from "../../../action/action";
import type {RRDate} from "@raskrask-dk/raskrask-utils";

export const SET_DATE = "SET_DATE";
export class SetDate extends Action<typeof SET_DATE, RRDate> {
  readonly type = SET_DATE;
  protected state: CalendarState;

  constructor(state: CalendarState, date?: RRDate) {
    super(state, date);
    this.state = state;
  }

  private matchingDate(needle: RRDate): (needle: RRDate) => boolean {
    return (straw: RRDate): boolean => straw.toString("yyyy-MM-dd") === needle.toString("yyyy-MM-dd");
  }

  public isValid(): boolean {
    if (!this.isDoable()) {
      return false;
    }

    const date = this.data;
    if (!this.hasValue(date)) return true;

    const {serviceType, partner} = this.state.getData();
    if (serviceType && !partner) {
      const serviceTypeHasDate = serviceType.doesProvide(date);
      return serviceTypeHasDate;
    }

    if (serviceType && partner) {
      const partnerHasDate = partner.schedule.datesAvilabilities(serviceType.duration).some(this.matchingDate(date));
      return partnerHasDate;
    }

    return false;
  }

  public isDoable(): boolean {
    const {serviceType, goal} = this.state.getData();
    const isRequiredValuesSet = this.allHasValues(serviceType, goal);
    return isRequiredValuesSet;
  }
}
